import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { convertNumbers } from "../../utils/ConvertNumbers";

const TableRecord = (props) => {
  return (
    <TableRow>
      <TableCell>
        <div
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "4px",
            backgroundColor: props.data.color,
          }}
        ></div>
      </TableCell>
      <TableCell align="center">{props.data.name}</TableCell>
      <TableCell align="center">
        {convertNumbers(props.data.percent.toFixed(2) + "%")}
      </TableCell>
    </TableRow>
  );
};

export default TableRecord;
